import { Fragment } from 'react'
import { HStack, Tag, useColorModeValue } from '@chakra-ui/react'
import { ChevronRight } from 'lucide-react'
import { useThemeColors } from '@/hooks/useThemeColors'

type LocationDetails = {
  region?: string | null
  areaCluster?: string | null
  province?: string | null
  town?: string | null
}

type Props = {
  locationDetails: LocationDetails
}

export default function LocationBreadcrumbChips({ locationDetails }: Props) {
  const colors = useThemeColors()
  const chipBg = useColorModeValue('#F5F4F2', 'gray.700')
  const segments = [
    locationDetails.region,
    locationDetails.areaCluster,
    locationDetails.province,
    locationDetails.town,
  ].filter((label): label is string => Boolean(label?.trim()))

  if (segments.length === 0) return null

  return (
    <HStack spacing={2} flexWrap="wrap" align="center">
      {segments.map((label, index) => (
        <Fragment key={`${label}-${index}`}>
          <Tag
            size="sm"
            borderRadius="md"
            bg={chipBg}
            color={colors.text}
            fontWeight="normal"
            fontSize="xs"
            px={2.5}
            py={1}
          >
            {label}
          </Tag>
          {index < segments.length - 1 ? (
            <ChevronRight size={14} color={colors.textMuted} aria-hidden />
          ) : null}
        </Fragment>
      ))}
    </HStack>
  )
}
